import { render, staticRenderFns } from "./App.vue?vue&type=template&id=dcf58152&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=dcf58152&scoped=true&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&global=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf58152",
  null
  
)

export default component.exports